// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EjJn","type":"styles_type__3xW8X","choices":"styles_choices__2Okyq"};